<td *ngIf="index && indexCons['show']" [ngClass]="indexCons?.class || 'tc-bg-01'">{{index}}</td>
<ng-container *ngFor="let rowData of datarow; let i=index">
  <ng-container *ngIf="customTemplates && rowData.templateName && customTemplates[rowData.templateName]">
    <ng-container *ngTemplateOutlet="customTemplates[rowData.templateName];context:{rowData: datarow, index:i}">
    </ng-container>
  </ng-container>
  <ng-container *ngIf="!customTemplates || !rowData.templateName || !customTemplates[rowData.templateName]">
    <td [ngStyle]="rowData.styles" (click)="cellInfo(datarow,$event,i,headers)" lib-table-cell [cellData]="rowData"
      [rowIndex]="index" (onOptionClick)="handleOptionClick($event)" (onWatchlistClick)="handleWatchlistClick($event)"
      (onCellClick)="click($event)" [isTotalData]="false" [ngClass]="rowData?.class || 'tc-bg-01'">
      <!-- [ngClass]="{'text-right': rowData.dataType == 'NUMBER' 
        || rowData.dataType == 'PERCENTAGE' 
        || rowData.dataType == 'CURRENCY'}" -->
    </td>
  </ng-container>
</ng-container>